export default "__VITE_ASSET__B7H77Umx__"